<header class="m-appbar" [class.m-appbar--without-leading]="!leadingIcon">
    @if (leadingIcon) {
        <button class="m-appbar__action" type="button" [attr.aria-label]="leadingLabel" (click)="leadingAction.emit()">
            <mat-icon aria-hidden="true">{{ leadingIcon }}</mat-icon>
        </button>
    }
    <div class="m-appbar__identity">
        <span>{{ eyebrow }}</span>
        <strong>{{ title }}</strong>
    </div>
    <div class="m-appbar__actions">
        <ng-content></ng-content>
        @if (actionIcon) {
            <button class="m-appbar__action" type="button" [attr.aria-label]="actionLabel" (click)="trailingAction.emit()">
                <mat-icon aria-hidden="true">{{ actionIcon }}</mat-icon>
            </button>
        }
    </div>
</header>
